import getNotificationPromptValueInLocalStorage from "./get-notification-prompt-value-in-local-storage";

const setNotificationPromptValueInLocalStorage = (options = {}) => {
	let { lastTimeAsked = null, ...newValue } = options;

	if (lastTimeAsked === null) {
		lastTimeAsked = Date.now();
	}

	window.localStorage.setItem(
		"airship-notification-prompt",
		JSON.stringify({
			...getNotificationPromptValueInLocalStorage(),
			...newValue,
			lastTimeAsked,
		})
	);
};

export default setNotificationPromptValueInLocalStorage;
